import { render } from "./InvitationReservation.vue?vue&type=template&id=4b446b16"
import script from "./InvitationReservation.vue?vue&type=script&lang=js"
export * from "./InvitationReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__